import axios from 'axios';
import { IUser } from './user.dto';

const url = `${process.env.GATSBY_TWILL_URL}/api/user`;

export async function getMe() {
  return axios.get<IUser>(url).then((response) => response.data);
}
